var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('div',{staticClass:"banner-content",style:({height: (_vm.screenHeight + "px")})},[_c('banner-layout')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }